export const en = {
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    approach: 'Approach',
    insights: 'Insights',
    testimonials: 'Testimonials',
    contact: 'Contact',
    cta: 'Request an introductory call',
    menu: 'Menu',
    close: 'Close',
  },
  footer: {
    aboutHeading: 'About Prof. Michaela Braun',
    about:
      'Prof. Michaela Braun is an attorney at law, certified business mediator, certified systemic-integrative business coach and certified Process Communication® coach. She practises at her law office in Munich and is a professor at the Hochschule der Bayerischen Wirtschaft (HDBW) as well as a lecturer at several other universities.',
    copyrightName: 'Prof. Michaela Braun',
    insights: 'Insights',
    speaking: 'Speaking',
    privacy: 'Privacy',
    legal: 'Legal Notice',
    cookies: 'Cookie Settings',
    contactTitle: 'Contact',
    contactSubtitle:
      'Briefly describe your concern. In an introductory call, we will clarify whether and in which space I can support you in a meaningful way.',
    namePlaceholder: 'Your name',
    emailPlaceholder: 'Your email',
    messagePlaceholder: 'Your message',
    send: 'SEND MESSAGE',
    logoAlt: 'Michaela Braun logo',
    mailSubject: (name) => `Message from the English website: ${name}`,
  },
  cookie: {
    title: 'Your privacy',
    before:
      'With your consent, I use Google Analytics to evaluate the use of this website on a pseudonymised basis. This involves setting cookies and may involve transferring data to the USA. You can change your decision at any time via "Cookie Settings" in the footer. Further information is available in the',
    link: 'Privacy Notice',
    after: '.',
    decline: 'DECLINE',
    accept: 'ACCEPT',
  },
  modal: {
    title: 'Request an introductory call',
    subtitle: 'Bitte füllen Sie das Formular aus. Ich melde mich schnellstmöglich bei Ihnen.',
    name: 'Name *',
    namePlaceholder: 'Your name',
    phone: 'Phone number *',
    phonePlaceholder: 'Your phone number',
    email: 'Email address *',
    emailPlaceholder: 'Your email address',
    website: 'Website',
    sending: 'Wird gesendet...',
    send: 'Send request',
    success: 'Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet. Ich melde mich bald bei Ihnen.',
    error:
      'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie mich direkt per E-Mail.',
    privacyBefore:
      'By submitting this form, your details will be sent to me so that I can process your appointment request. Further information is available in the',
    privacyLink: 'Privacy Notice',
    privacyAfter: '.',
    close: 'Close',
  },
  home: {
    heroAria: 'Einstieg',
    eyebrow: 'COACHING · MEDIATION · EXECUTIVE ADVISORY',
    title: 'Change demands truth.',
    sub: 'This is where it becomes visible.',
    audience:
      'For business owners and executives facing a negotiation, a conflict or a succession that is too significant for routine.',
    cta: 'Request an introductory call',
    roomsLink: 'Explore the three spaces',
    roomsAria: 'Die drei Spiegel-Räume',
    roomsHeading: 'The three spaces',
    roomsIntro:
      'Attorney, mediator and coach in one person: you see not only the human dynamics, but also what is at stake legally and commercially.',
    formatLabel: 'Format:',
    profileAria: 'Profil',
    profileHeading: 'Profile',
    profile:
      'Attorney, mediator, coach and honorary professor, with more than 25 years of experience advising business owners, successors and executives.',
    closingAria: 'Abschluss',
    closing: 'When change is on the horizon, clarity begins with a conversation.',
    logoAlt: 'Michaela Braun',
  },
  rooms: [
    {
      id: 'einszueins',
      title: '1:1 Mirror Work',
      edge: 'cta',
      subtitle: 'For decision-makers before and during defining moments',
      body: 'A negotiation that will shape the years ahead. A team that does not support your leadership. A change of role that demands more than experience. In one-to-one work, you will recognise which patterns carry you and which hold you back, and you will prepare the decisive step with precision.',
      occasions: [
        'High-stakes negotiations and conversations',
        'Leading against resistance',
        'Role changes, succession and new responsibilities',
      ],
      format: 'Online or in person. The scope is determined by the matter at hand, not by the clock.',
    },
    {
      id: 'systeme',
      title: 'Mirror Work for Systems',
      edge: 'mirror',
      subtitle: 'For leadership teams, project teams and family businesses',
      body: 'When a system has become stuck, the problem rarely lies with a single person. Workshops and mediation make visible how your system actually works and where it can be moved.',
      occasions: [
        'Conflicts within the leadership team or project management, as mediation',
        'Power, roles and expectations in the family business',
        'Negotiation skills and a culture of feedback and conflict, as a workshop',
      ],
      format: 'Half-day or full-day, in-house or at a neutral venue.',
    },
    {
      id: 'zirkel',
      title: 'Mirror Work for Presence and Integrity',
      edge: 'heading',
      subtitle: 'For executives and high potentials on their way into top management',
      body: 'At the top level, expertise alone rarely decides; presence and informal power do. In one-to-one work, you will recognise how you come across there, where the lines are drawn that you should hold, and what it takes to hold your own at that level.',
      occasions: [
        'Presence and positioning before the board and top management',
        'Informal power and unwritten rules',
        'Conflicts of loyalty between targets, compliance and personal values',
      ],
      format: 'Online or in person. On request as a programme for several executives within one organisation, always as individual work.',
    },
  ],
  about: {
    label: 'ABOUT MICHAELA BRAUN',
    p1: 'I work with business owners and executives at moments when a great deal is at stake: in critical negotiations, in entrenched conflicts and in transitions within family businesses.',
    p2: 'After studying at LMU Munich and the University of Vienna and working at Tulane University (USA), I was admitted to the bar in 1992 and have been teaching since 2013. Today I am an honorary professor of business law and entrepreneurship at HDBW Munich and a lecturer in the "Family Owned Businesses" specialisation at Zeppelin University and Munich Business School.',
    p3: 'I complement my experience from countless mandates in commercial, contract and family law with my qualifications as a certified business mediator, certified systemic-integrative business coach and certified PCM coach.',
    p4: 'This allows me to combine sound legal expertise with a deep understanding of human dynamics, emotional processes and effective communication.',
    link: 'Insights & Perspectives →',
    photoAlt: 'Michaela Braun',
    crumb: 'About',
  },
  services: {
    label: 'SERVICES',
    title: '1:1 Mirror Work, Mirror Work for Systems, Mirror Work for Presence and Integrity',
    intro:
      'Three spaces for moments when a great deal is at stake. You choose according to your situation, not according to the method.',
    talks: 'Talks for your event',
    crumb: 'Services',
    alts: ['1:1 Mirror Work', 'Mirror Work for Systems', 'Mirror Work for Presence and Integrity'],
    address: 'Kirchenstraße 87 b, 81675 Munich, Germany',
  },
  contact: {
    label: 'CONTACT',
    title: 'Get in touch',
    intro:
      'Briefly describe your concern. In an introductory call, we will clarify whether and in which space I can support you in a meaningful way.',
    email: 'EMAIL',
    office: 'PHONE (OFFICE)',
    mobile: 'PHONE (MOBILE)',
    ask: 'Would you like to arrange a personal conversation?',
    cta: 'Request an introductory call',
    crumb: 'Contact',
  },
  speaking: {
    label: 'SPEAKING',
    title: 'Professional clarity. Human impact.',
    p1: 'In my talks, I combine legal expertise, many years of advisory experience and modern methods from communication and leadership practice.',
    p2: 'I speak on communication, difficult conversations, negotiation techniques and leadership, always with the aim of making complex content accessible and providing practical insights that help immediately in everyday professional life.',
    caption: "Talk at the Bavarian Notaries' Association (Bayerischer Notarverein)",
    cta: 'Enquire for your event',
    alt: "Talk at the Bavarian Notaries' Association (Bayerischer Notarverein)",
    crumb: 'Speaking',
  },
  testimonials: {
    title: 'Testimonials',
    note: 'Translated from German.',
    aria: 'Testimonials',
    crumb: 'Testimonials',
    voices: [
      {
        quote:
          'My concern was how to lead a team that did not accept me as their boss. During the coaching sessions, it became clear what I myself had contributed to this dynamic. Since then I have felt more confident, and my team reflects this back through good collaboration. The most important thing for me was to stop explaining myself whenever I have to make a decision.',
        attribution: 'MANAGING DIRECTOR, MEDIUM-SIZED COMPANY',
      },
      {
        quote:
          'Our leadership team had become stuck in turf wars that nobody addressed openly. We therefore decided on a joint workshop. It was a space in which, for the first time, we saw together how our system actually works. That was not always comfortable. But I would never have thought possible the conversations we have been able to have since.',
        attribution: 'DIVISION HEAD, TECHNOLOGY COMPANY',
      },
      {
        quote:
          'Ahead of a very important career step, and despite my experience, I decided to get support with the negotiation. It was a very good decision. I recognised typical, mostly counterproductive behavioural patterns. Ms Braun reflected them back to me precisely and without beating about the bush. That clarity was exactly what I had been missing.',
        attribution: 'PARTNER, MANAGEMENT CONSULTANCY',
      },
      {
        quote:
          "I am extremely satisfied with Prof. Braun's support, as she listens actively and responds precisely to my individual needs. She combines her extensive expertise and the highest level of professionalism with genuine empathy. What I value most are her concrete tips, which I can put into practice immediately in my day-to-day leadership.",
        attribution: 'HEAD OF DEPARTMENT, DEFENCE INDUSTRY',
      },
      {
        quote:
          "During one of our projects, personal differences arose within the project management that seriously threatened the success of the project. Through Ms Braun's goal-oriented mediation, the conflicts were resolved constructively. Our collaboration was brought back to a professional level, communication became clearer and mutual trust was strengthened.",
        attribution: 'HEAD OF DEPARTMENT, DEFENCE SECTOR',
      },
      {
        quote:
          'I went straight into management consulting after university and quickly realised that good content alone is not enough. With Ms Braun, I worked on how I present to management and how I position myself with colleagues and superiors. She gave me honest feedback on where my impact did not yet match my aspirations, and at the same time gave me very concrete tools. I am convinced that the coaching helped me become a Senior Consultant faster. And I still use those tools in my daily work.',
        attribution: 'SENIOR CONSULTANT, MANAGEMENT CONSULTANCY',
      },
    ],
  },
  insights: {
    label: 'INSIGHTS',
    title: 'Perspectives',
    intro: 'Articles on reflection, leadership and structural change, published at irregular intervals.',
    empty: 'Der erste Beitrag folgt in Kürze.',
    back: 'Mehr über Michaela Braun →',
    crumb: 'Insights',
  },
  legal: {
    back: '← Back to home page',
    title: 'Legal Notice',
    note: 'This English translation is provided for convenience only. In case of discrepancies, the German version shall prevail.',
    crumb: 'Legal Notice',
  },
  privacyPage: {
    back: '← Back to home page',
    note: 'This English translation is provided for convenience only. In case of discrepancies, the German version shall prevail.',
    crumb: 'Privacy Notice',
  },
  seo: {
    home: {
      title: 'Prof. Michaela Braun | Change Demands Truth',
      description:
        'For business owners and executives in critical negotiations, leadership conflicts and succession. Attorney, mediator and coach in Munich.',
    },
    about: {
      title: 'About | Prof. Michaela Braun, Munich',
      description:
        'Attorney, mediator, coach and honorary professor in Munich. Support in negotiations, conflicts and family businesses.',
    },
    services: {
      title: 'Three Spaces of Mirror Work | Michaela Braun',
      description:
        '1:1 Mirror Work, Mirror Work for Systems, and Mirror Work for Presence and Integrity. For negotiations, conflicts and top management.',
    },
    testimonials: {
      title: 'Testimonials | Coaching and Mediation',
      description:
        'Feedback from managing directors, leadership teams and consultants on coaching, mediation and workshops with Prof. Michaela Braun.',
    },
    insights: {
      title: 'Insights on Leadership and Impact | Michaela Braun',
      description:
        'Articles by Prof. Michaela Braun on the image others have of you, and why power games hold women back.',
    },
    speaking: {
      title: 'Talks on Leadership and Negotiation | Michaela Braun',
      description:
        'Talks on communication, difficult conversations, negotiation techniques and leadership by Prof. Michaela Braun.',
    },
    contact: {
      title: 'Contact | Introductory Call in Munich',
      description:
        'Briefly describe your concern. In an introductory call we clarify whether mirror work, support for systems or a talk fits.',
    },
    legal: {
      title: 'Legal Notice | Michaela Braun',
      description:
        'Information pursuant to Section 5 of the German Digital Services Act (DDG) and Section 18 (2) of the German Interstate Media Treaty (MStV).',
    },
    privacy: {
      title: 'Privacy Notice | Michaela Braun',
      description:
        'Privacy notice for clients on coaching, mediation and workshops, pursuant to the GDPR.',
    },
  },
};
